module.exports = __webpack_public_path__ + "static/37-0951ab0216ba345363a2fc068f775a7e.png";